//保存用户信息
export const SAVEUSERINFO = 'save user info';


// WEBPACK FOOTER //
// ./src/store/user/actionType.js